import { render } from "./UserAchievements.vue?vue&type=template&id=85077e6a&scoped=true"
import script from "./UserAchievements.vue?vue&type=script&lang=js"
export * from "./UserAchievements.vue?vue&type=script&lang=js"

import "./UserAchievements.vue?vue&type=style&index=0&id=85077e6a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85077e6a"]])

export default __exports__